'use client';
import { chakra } from '../system/factory.mjs';

const Box = chakra("div");
Box.displayName = "Box";

export { Box };
